import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { DatePipe } from '@angular/common';
declare var app;

@Component({
  selector: 'app-mz-approval-person',
  templateUrl: './mz-approval-person.component.html',
  styleUrls: ['./mz-approval-person.component.scss']
})
export class MzApprovalPersonComponent extends GridBaseCase {
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  searchValuename: any = "";
  dataArrayList: Array<any> = [];
  // numkkkk= 180;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); 
    this.baseService.FixedSubmitBtn.configName = "approvalperson";
 
    this.baseService.FixedSubmitBtn.text = "审批通过";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.type = 21;
     /**
     * 设置默认当前年月
     */
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
  }

  // ngOnInit() {
  // }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      let obj = {};
       if (!that.searchDate) {
        let nowyear: any = that.com.getNow.split('-')[0];
        let nowmonth: any = that.com.getNow.split('-')[1];
        obj['beginDate'] = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        obj['endDate'] = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
       
      }else{
        if(that.searchDate && that.searcholdDate){
          obj['beginDate'] = that.searchDate;
          obj['endDate'] = that.searcholdDate;
        }

      }

      // //请假列表
      // if (that.searchDate) {
      //   // a_Sub_FK_SystemUser_ID//审批人ID
      //   obj["a_SNStartDate"] = that.searchDate;
        
      // }
      if (that.segmentVal) {//审批状态
        obj["a_SNState"] = that.segmentVal;
      } else {
        obj["a_SNState"] = 0;
      }
      if(that.searchValuename){
        obj["chineseName"] = that.searchValuename;
      }
      // obj["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
      body.RequestBody = JSON.stringify(obj);
      // if(that.baseService.storeSearch.name){

      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id,"a_name":that.baseService.storeSearch.name});
      // }else{
      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
      // }
      // body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
    }
    console.log(123456);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              if(element.bindingField == "date"){
                objfield[element.bindingField] = { "value": item[element.field].replace(/-/g,"/"), "text": element.text };
              }else{
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  searchEvent(e, type: string = 'type') {
    const that = this; 
    if (e.keyCode == 13 || type == 'search') {
      // that.msg.Confirm("点击确定，如有选中都将被清空","取消","确定").then(fail=>{
      //   if(fail){
      //     that.LoadData(1);
      //   }
      // });
      that.LoadData(1);
      that.EventCheckAllToggle();
    }
   
  }
  changeMonth(type, $event:any = "") {
    const that=this;
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = that.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
      
      
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    this.searchDate =startmonthDay;
    this.searcholdDate = endmonthDay;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }
  EventClick(index) {
    const that = this;
    that.segmentVal = index;
    if(index==0){
      that.baseService.FixedSubmitBtn.type = 21;
      
    }
    else if(index==1){
      that.baseService.FixedSubmitBtn.type = 22;
    }
    else{
      that.baseService.FixedSubmitBtn.type = 60000;
    }
   
    that.LoadData(1);
  }
  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    let d = new Date(this.month);
    let current = d.getFullYear() + "-" + (d.getMonth()+1);
    console.log(evs, parms);
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs, '详情');
      } else {
        // this.router.navigateByUrl(evs + "/GETEDITE/");
        //TODO:跳转方法
        this.segmentVal?this.segmentVal:0;
        // this.router.navigateByUrl(evs + "/1/" + parms.SystemUser_ID.value);
        this.com.setHistoryUrl(false);
        this.com.Go(evs + "/" + this.segmentVal + "/" + parms.FK_SystemUser_ID.value + "&" +current+"&"+this.com.getNowDatetime);
      }
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }


  checkItem(item,i,event){
    const that=this;
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
    let istrue:number=0;
    that.dataArrayList.forEach(items => {
      if(items.isCheck){
        istrue++;
      }
    });
    if(istrue==that.dataArrayList.length){
      that.baseService.FixedSubmitBtn["isCheckAll"]=true;
    }else{
      that.baseService.FixedSubmitBtn["isCheckAll"]=false;
    }
  }
    /**
   * 审批
   * @param event 通过:true,驳回:false
   */
  EventSubmit(event: Boolean) {
    // console.log(event);
    const that = this;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalSystemUser";//审批人审批
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        if (items.isCheck) {
          that.addobject.push(items.FK_SystemUser_ID.value);//用户ID
        }
      });
      let message:string = "审批";
      if(!event){
        message="驳回";
      }
      if(that.addobject.length<=0){
        that.msg.Alert("请选择需要"+message+"的排班");
        return;
      }
      ////debugger;
      let datepipe =new DatePipe("en-US");
      let isapprove:boolean=true;//是否可撤销
      let _monthDate:any = parseInt(that.com.getNowYearAndMonth.replace(/-/g, "").replace("/", ""));
      that.dataArrayList.forEach(items=>{
        if(items.isCheck){
          let date:any= datepipe.transform(items.date.value.replace(/-/g, "/"),"yyyy-MM");//撤销的日期
          date=parseInt(date.replace(/-/g, "").replace("/", ""));
          if(date<_monthDate){
            isapprove=false;
          }
        }
        
      });
      if(!isapprove){
        that.msg.Alert("只能"+message+"当天之后的排班");
        return;
      }
      let _bodyparms={};
      let users="";
      that.addobject.forEach(user=>{
          if(!users){
            users=user;
          }else{
            users +=","+user;
          }
      });
      users+=","+"711BBD40-6A3C-41CA-B288-925A415EB7B7";
      var msgError:any="";
           _bodyparms["userId"]=users;
           _bodyparms["date"]= that.month;
           if(event){
            _bodyparms["state"]=1;//审批通过
            msgError="审批通过";
           }else{
            _bodyparms["state"]=2;//审批驳回
            msgError="审批驳回";
           }
           
       console.log(JSON.stringify(_bodyparms));
      webcontext.RequestBody = JSON.stringify(_bodyparms);
      console.log(JSON.stringify(webcontext));

      that.msg.Confirm("确定"+message+"吗？","取消","确定").then(res=>{
        if(res){
          that.http.post(app.DEFAULTURL, webcontext).then(data => {
            if (data.ResponseMessage.Success) {
               that.msg.Alert("排班"+message+"成功").then(res=>{
                that.LoadData(1);
               });
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          });
        }
      });
  
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  ///撤销数据
  EventApproveSubmit(){
    const that = this;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "TBScheduleNormalSystemUser";//审批人审批
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        if (items.isCheck) {
          that.addobject.push(items.FK_SystemUser_ID.value);//用户ID
        }
      });
      if(that.addobject.length<=0){
        that.msg.Alert("请选择需要撤销的排班");
        return;
      }
      let datepipe =new DatePipe("en-US");
      let isapprove:boolean=true;//是否可撤销
      let _monthDate:any = parseInt(that.com.getNowYearAndMonth.replace(/-/g, "").replace("/", ""));
      that.dataArrayList.forEach(items=>{
        if(items.isCheck){
          let date:any= datepipe.transform(items.date.value.replace(/-/g, "/"),"yyyy-MM");//撤销的日期
          date=parseInt(date.replace(/-/g, "").replace("/", ""));
          if(date<_monthDate){
            isapprove=false;
          }
        }
        
      });
      if(!isapprove){
        that.msg.Alert("只能撤销当天之后的排班");
        return;
      }
      let _bodyparms={};
      let users="";
      that.addobject.forEach(user=>{
          if(!users){
            users=user;
          }else{
            users +=","+user;
          }
      });
      // users+=","+"711BBD40-6A3C-41CA-B288-925A415EB7B7";
           _bodyparms["userId"]=users;
           _bodyparms["date"]= that.month;
           _bodyparms["state"]=3;//批量撤销
           
      //  console.log(JSON.stringify(_bodyparms));
      webcontext.RequestBody = JSON.stringify(_bodyparms);
      that.msg.Confirm("确定撤销吗？","取消","确定").then(res=>{
        if(res){
            that.http.post(app.DEFAULTURL, webcontext).then(data => {
              if (data.ResponseMessage.Success) {
                that.msg.Alert("排班撤销成功").then(msg=>{
                  that.LoadData(1);
                });
              } else {
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            });
        }
      });
    
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
   /**
   * 全选状态切换
   */
  EventCheckAllToggle() {
    const that = this;
    if (that.baseService.FixedSubmitBtn["isCheckAll"]) {
      that.dataArrayList.forEach(items => {
        console.log(items,"集合");
        items.isCheck = true;
      });
    } else {
      that.dataArrayList.forEach(items => {
        items.isCheck = false;
      });
    }
  }

}
